import React, { useState,useEffect,useRef } from "react";
import { useParams } from 'react-router-dom';
import arrowtopoutline from '../../images/arrow-top-outline.svg';
import saveoutline from '../../images/save-outline.svg';
import unsaveoutline from '../../images/unsave-outline.svg';
import heartoutline from '../../images/heart-outline.svg';
import likeheartoutline from '../../images/like-heart-outline.svg';
import save from '../../images/save.svg'
import location from '../../images/location.svg';
import brochure from '../../images/brochure.svg';
import floorplan from '../../images/floor-plan.svg';
import website from '../../images/website.svg';
import bedroom from '../../images/bedroom.svg';
import bathroom from '../../images/bathroom.svg';
import sqft from '../../images/sqft.svg';
import profile_img from '../../images/profile_img.svg';
import comment from '../../images/comment.svg';
import profile_with_v from '../../images/profile_with_v.svg';
import backarrow from '../../images/back-arrow.svg';
import heart from '../../images/heart.svg';
import arrowup from '../../images/arrow-up.svg';
import vshort from '../../images/v-short.svg';
import noImage  from '../../images/no-image.jpg';

import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { ASSETS_URL } from "../../constants/apiConstants";
import { Bearer_Token } from "../../constants/apiConstants";
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import { Mousewheel, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination'; 
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import { Link } from "react-router-dom";
import 'photoswipe/dist/photoswipe.css'
import { Gallery, Item } from 'react-photoswipe-gallery'
import { useGallery } from "react-photoswipe-gallery";
import Modal from 'react-modal';
import arrow from '../../images/arrow.svg';
import { ToastContainer, toast, Slide } from "react-toastify";
import { ReactComponent as Loader } from '../../images/loader.svg'

const customStylesLogin = {
    content: {
      top: '0px',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '0',
      transform: 'translate(-50%, 0%)',
      background: 'none',
      border: 'none',
      paddingTop:'100px',
      zIndex:'999'

    },
    overlay: {
       top: 0
    },
};

function Details() {
    const token = localStorage.getItem("ACCESS_TOKEN");
    const { id } = useParams();
    const [property,setProperty] = useState([]);
    const [amenities,setAmenities] = useState([]);
    const [propertyPhotos,setPropertyPhotos] = useState([]);
    const [userName, setUserName] = useState('');
    const [name, setName] = useState('');
    const [agentImage,setAgentImage] = useState(null);
    const [agentVerified,setAgentVerified] = useState(null);

    const [brokerageUserName, setBrokerageUserName] = useState('');
    const [brokerageName, setBrokerageName] = useState('');
    const [brokerageImage,setBrokerageImage] = useState(null);
    const [brokerageVerified,setBrokerageVerified] = useState(null);

    const [developerUserName, setDeveloperUserName] = useState('');
    const [developerName, setDeveloperName] = useState('');
    const [developerImage,setDeveloperImage] = useState(null);
    const [developerVerified,setDeveloperVerified] = useState(null);

    const [imageLength,setImageLength] = useState(0);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [brochureFile, setBrochureFile] = useState(null);
    const [isLike, setIsLike] = useState(null);
    const [isSaved, setIsSaved] = useState(null);
    const [brochureModalIsOpen, setBrochureModalIsOpen] = React.useState(false);
    const [loading, setLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(1);
    
    const getProperty = (e) => {
        axios.get(API_BASE_URL+'get/property/'+id,{
            headers: {
                Authorization: `Bearer ${Bearer_Token}`,
            }
        })
        .then(function (response){
            setProperty(response.data.data);
            setAmenities(response.data.data.amenities.join(' | '));
            setPropertyPhotos(response.data.data.photos);
            if(response.data.data.photos.length < 6){
                setImageLength(5);
            }else{
                setImageLength(6);
            }
            setUserName(response.data.data.user.user_name);
            setName(response.data.data.user.name);
            setAgentImage(response.data.data.user.profile_picture);
            setAgentVerified(response.data.data.user.is_verified);

            setBrokerageUserName(response.data.data.brokerage.user_name);
            setBrokerageName(response.data.data.brokerage.name);
            setBrokerageVerified(response.data.data.brokerage.is_verified);

            setBrokerageImage(response.data.data.brokerage.profile_picture);
            setDeveloperUserName(response.data.data.developer.user_name);
            setDeveloperName(response.data.data.developer.name);
            setDeveloperVerified(response.data.data.developer.is_verified);
            setDeveloperImage(response.data.data.developer.profile_picture);
            setIsLike(response.data.data.is_like);
            setIsSaved(response.data.data.is_bookmark);
        })
        .catch((error) => {
            toast.error(error, {
                position: "top-right",
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
            });
        })
    }

    let subtitle;
    function openBrochureModal(brochure) {
        document.body.style.overflow = 'hidden';
        setBrochureModalIsOpen(true);
        setBrochureFile(ASSETS_URL+'properties/brochure/'+brochure)
    }

    function openFloorPlanModal(brochure) {
        document.body.style.overflow = 'hidden';
        setBrochureModalIsOpen(true);
        setBrochureFile(ASSETS_URL+'properties/floorplan/'+brochure)
    }

    function afterOpenModal() {
        subtitle.style.color = '#f00';
    }

    function closeLogInModal() {
        document.body.style.overflow = 'unset';
        setBrochureModalIsOpen(false);
    }

    const toggleLike = (item, status) => {
        if (status === 1) {
            setIsLike(false);
        }else{
            setIsLike(true);
        }

        const payload = {
            property_id: item,
            type: 2,
        };
        axios
        .post(API_BASE_URL + "add/like", payload, {
            headers: {
            Authorization: `Bearer ${Bearer_Token}`,
            },
        })
        .then((response) => {
            
        })
        .catch((error) => {
            toast.error(error, {
                position: "top-right",
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
            });
        });
    };

    const toggleSaved = (item, status) => {
        if (status === 1) {
            setIsSaved(false);
        }else{
            setIsSaved(true);
        }

        const payload = {
            property_id: item,
        };
        axios
        .post(API_BASE_URL + "add/bookmark", payload, {
            headers: {
            Authorization: `Bearer ${Bearer_Token}`,
            },
        })
        .then((response) => {})
        .catch((error) => {
            toast.error(error, {
            position: "top-right",
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            });
        });
    };

    const firstLogin = () => {
        toast.error("Please login to this event.", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            theme: "dark",
            transition: Slide,
        });
    };

    const handleSlideChange = (swiper) => {
        setCurrentIndex(swiper.activeIndex);
        console.log(swiper.activeIndex);
    };

    const openFirstImageRef = useRef(null);

    useEffect(()=> {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        getProperty()
    },[]);

    return (
    <>
        <ToastContainer />
        <Modal
            isOpen={brochureModalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeLogInModal}
            style={customStylesLogin}
            contentLabel="Example Modal"
            bodyOpenClassName="modal-open2"
        >
            <h3 ref={(_subtitle) => (subtitle = _subtitle)}></h3>
            
            <div class="modal_box3">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal_boxnew">
                            <button className="button_story_pop1" onClick={closeLogInModal}><img src={arrow} alt="arrow" /></button>
                            <div className="row">
                            {loading && (
                            <div
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgb(255, 255, 255)',
                                zIndex: 1,
                            }}
                            >
                            <p>
                                <button type="submit" class="btn btn-lg gredient_bg1 btn-block" disabled={true}> 
                                    <Loader className="login-spinner" />
                                </button>
                            </p>
                            </div>
                            )}
                            <iframe src={brochureFile} className="property-files" frameborder="0" allowfullscreen onLoad={() => setLoading(false)}></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>

        <section class="grid_box">
            <div class="container">
                <div class="text_he_box text_he_box2  ">
                    <div class="row justify-content-between align-items-center">
                        <div class="col-md-6">
                            <div class="d-flex flex-wrap justify-content-between align-items-center">
                                <h4><Link to="/"><img src={backarrow} alt="" /></Link> <span className="p-sale">Properties for Sale -</span><span> {property.title} </span></h4>
                                <h5>Verified Property</h5>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <div class="d-flex flex-wrap justify-content-between align-items-center px-0 px-lg-5">
                                <ul>
                                    <li><a href="#">Share <img src={arrowtopoutline} alt="" /></a></li>

                                    {token && token !== "undefined" ? (
                                        property.is_bookmark === true ? (
                                            isSaved === true ? (
                                                <li><a href="#" onClick={() => toggleSaved(property.id, 1)}>Save <img src={unsaveoutline} alt="" /></a></li>
                                            ) : (
                                                <li><a href="#" onClick={() => toggleSaved(property.id, 2)}>Save <img src={saveoutline} alt="" /></a></li>
                                            )
                                        ) : (

                                            isSaved === true ? (
                                                <li><a href="#" onClick={() => toggleSaved(property.id, 1)}>Save <img src={unsaveoutline} alt="" /></a></li>
                                            ) : (
                                                <li><a href="#" onClick={() => toggleSaved(property.id, 2)}>Save <img src={saveoutline} alt="" /></a></li>
                                            )
                                        )

                                    ) : (
                                        <li><a href="#" onClick={firstLogin}>Save <img src={saveoutline} alt="" /></a></li>
                                    )}

                                    {token && token !== "undefined" ? (
                                        property.is_like === true ? (
                                            isLike === true ? (
                                                <li><a href="#" onClick={() => toggleLike(property.id, 1)}>Save <img src={likeheartoutline} alt="" /></a></li>
                                            ) : (
                                                <li><a href="#" onClick={() => toggleLike(property.id, 2)}>Save <img src={heartoutline} alt="" /></a></li>
                                            )
                                            
                                        ) : (
                                            isLike === true ? (
                                                <li><a href="#" onClick={() => toggleLike(property.id, 1)}>Save <img src={likeheartoutline} alt="" /></a></li>
                                            ) : (
                                                <li><a href="#" onClick={() => toggleLike(property.id, 2)}>Save <img src={heartoutline} alt="" /></a></li>
                                            )
                                        )
                                    ) : (
                                        <li><a href="#" onClick={firstLogin}>Like <img src={heartoutline} alt="" /></a></li>
                                    )}
                                </ul>
                                {/* <a href="#" class="button_gredient">PUBLISH NOW</a> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="middle_section">
            <div class="container">
                <div class="row">
                    <div class="col-xxl-6 col-xl-4 col-lg-4 col-md-12 col-sm-12">
                        <div className="boximg-frame">
                    {propertyPhotos.length > 0  &&
                    <Swiper
                        style={{
                        '--swiper-navigation-color': '#fff',
                        '--swiper-pagination-color': '#fff',
                        }}
                        loop={true}
                        spaceBetween={10}
                        navigation={false}
                        thumbs={{ swiper: thumbsSwiper }}
                        modules={[FreeMode, Navigation, Thumbs,Mousewheel,Pagination]}
                        className="mySwiper2"
                        pagination={{
                            clickable: true,
                            dynamicBullets: true,
                        }}
                        onSlideChange={handleSlideChange}
                        onSwiper={(swiper) => console.log('swiper',swiper)}
                        mousewheel={true}
                    >
                        {propertyPhotos.map((item) => (
                        <SwiperSlide
                        >
                            
                            <img class="box_frame" src={ASSETS_URL+"properties/media/medium/"+item} width="100%" alt="" onClick={() => {
                            if (openFirstImageRef.current) {
                                openFirstImageRef.current();
                            }
                            }}/>
                            
                        </SwiperSlide>
                        ))}
                    </Swiper>
                    }
                    </div>

                        {/* <img class="box_frame" src={ASSETS_URL+"properties/media/medium/"+property.cover_photo} width="100%" alt="" /> */}
                        <div class="text_he_box2">
                            <h4>{property.description_title}</h4>
                            <Link to={`/property/images/${property.id}`} className="view-all-image"><h4 class="view-all text-end">View All Photos</h4></Link>
                        </div>
                        {propertyPhotos.length > 0  &&
                        <div class="photo_gal flex-wrap justify-content-between align-items-center mt-5">
                            <Swiper
                                onSwiper={setThumbsSwiper}
                                loop={false}
                                speed={100}
                                cssMode={window.safari !== undefined}
                                edgeSwipeDetection={true}
                                spaceBetween={30}
                                slidesPerView={imageLength}
                                freeMode={true}
                                watchSlidesProgress={true}
                                modules={[FreeMode, Navigation, Thumbs,Mousewheel]}
                                className="mySwiper1"
                                mousewheel={true}
                                breakpoints={{
                                    
                                    320: {
                                    slidesPerView: 3,
                                    },
                                    579: {
                                    slidesPerView: 4,
                                    },
                                    768: {
                                    slidesPerView: 5,
                                    },
                                    1024: {
                                    slidesPerView: 5,
                                    },
                                }}
                            >
                            {propertyPhotos.map((item) => (
                                <SwiperSlide>
                                    <img className="property-media-image" src={ASSETS_URL+"properties/media/small/"+item} alt="" width={95} height={95} />
                                </SwiperSlide>

                                // <div class="col"> <img className="property-media-image" src={ASSETS_URL+"properties/media/small/"+item} alt="" width={95} height={95} /> </div>
                            ))}
                            </Swiper>
                        </div>
                        }
                    </div>
                    <div class="col-xxl-6 col-xl-8 col-lg-8 col-md-12 col-sm-12">
                        <div class="box_bg_color right_side_box">
                            <h4>{property.title}</h4>
                            <span class="right_side_box_span">
                            {/* <img src={location} width="15px" alt="" />  */}
                            {property.location_title}</span>
                            <div class="row justify-content-between">
                                <div class="col-md-5">
                                    <div class="hightlights">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h5>Highlights</h5>
                                            <span>PENTHOUSE</span>
                                        </div>
                                    </div>
                                    <div class="amanities">
                                        <ul>
                                            <li>{amenities}</li>
                                        </ul>
                                    </div>
                                    <div class="box_blank"></div>
                                    <div class="most_links">
                                        <ul>
                                            <div class="d-flex justify-content-between">
                                                {property.brochure !== 'Armani-Beach-Residence-BrochureLow.pdf' &&
                                                <li>
                                                    {/* {property.brochure ?
                                                        <a onClick={() => openBrochureModal(property.brochure)} href='#'><img src={brochure} alt="" /> <br /> BROCHURE</a>
                                                    :
                                                        <a href="#"><img src={brochure} alt="" /> <br /> BROCHURE</a>
                                                    } */}
                                                    <a onClick={() => openBrochureModal(property.brochure)} href='#'><img src={brochure} alt="" /> <br /> BROCHURE</a>
                                                </li>
                                                }
                                                {property.floor_plan !== 'Armani-Beach-Residence-FloorPlan.pdf' &&
                                                <li>
                                                    {/* {property.floor_plan ?
                                                        <a href="#" onClick={() => openFloorPlanModal(property.floor_plan)}><img src={floorplan} alt="" /> <br /> FLOOR PLAN </a>
                                                    :
                                                        <a href="#"><img src={floorplan} alt="" /> <br /> FLOOR PLAN </a>
                                                    } */}
                                                    <a href="#" onClick={() => openFloorPlanModal(property.floor_plan)}><img src={floorplan} alt="" /> <br /> FLOOR PLAN </a>
                                                </li>
                                                }
                                                {property.website &&
                                                    <li><a href={property.website} target="_blank"><img src={website} alt="" /><br /> WEBSITE </a></li>
                                                }
                                            </div>
                                        </ul>
                                        <span class="border_radius_gredient"></span>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="hightlights hightlights_bor  mb-0">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <h5>Price</h5>
                                            <span>SALE</span>
                                        </div>
                                    </div>
                                    <div class="aedprice">
                                        <h2>
                                        {(() => {
                                            switch (property.currency) {
                                            case "AED":   return  new Intl.NumberFormat("en-AE", { style: "currency", currency: "AED", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                            case "USD": return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                            case "GBP":  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                            case "EUR":  new Intl.NumberFormat("en-BE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                            case "INR":  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                            default:      return "";
                                            }
                                        })()}
                                        </h2>
                                        <div class="d-flex flex-wrap justify-content-between align-items-center">
                                        <span>Get this property </span>
                                        <a href="#" class="button_gredient">RESERVE NOW</a>
                                        </div>
                                    </div>
                                    <div class="most_links">
                                        <ul>
                                        <div class="d-flex justify-content-between">
                                            <li><a href="#"><img src={bedroom} alt="" /> <br /> {property.number_of_bedroom} BEDROOMS </a></li>
                                            <li><a href="#"><img src={bathroom} alt="" /> <br /> {property.number_of_bathroom} BATHROOMS </a></li>
                                            <li><a href="#"><img src={sqft} alt="" /><br /> {property.square_feet} SQ FT</a></li>
                                        </div>
                                        </ul>
                                        <span class="border_radius_gredient"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sale_box">
                            <div class="row justify-content-between">
                                <div class="col-md-5">
                                    <div class="head_sale">
                                        <h6>Chat with your Broker</h6>
                                        <div class="sanda_box">
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="pro-im-b">
                                                {agentImage ?
                                                    <img src={ASSETS_URL+'agent/profile/'+agentImage} alt=""/>
                                                :
                                                    <img src={noImage} alt=""/>
                                                }
                                                {/* <img src={profile_img} alt="" /> */}
                                                <span>{userName}</span>
                                            </div>
                                            <div class="img_comment">
                                                <img src={comment} alt="" />
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    
                                    <div class="profile_box pro-b2 text-center">
                                        <Link to='/broker/details'>
                                        <span>VERIFIED BROKER</span>
                                        <div class="position-relative d-inline">
                                            {agentImage ?
                                                <img className="agent-profile-picture" src={ASSETS_URL+'agent/profile/'+agentImage} alt=""/>
                                            :
                                                <img className="agent-profile-picture" src={noImage} alt=""/>
                                            }
                                            <img className="v-agent-profile" src={vshort} alt=""/>
                                        </div>
                                        <h5>{userName}</h5>
                                        <h4>{name}</h4>
                                        {/* <img src={profile_with_v} alt="" />
                                        <h5>sanda</h5>
                                        <h4>Sanda Ali</h4> */}
                                        <p>on Verified Properties since 1 May 2025</p>
                                        </Link>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                <span class="border_radius_gredient"></span>
                </div>
            </div>
            <div class="armani_box">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="left_aside">
                                <h2>{property.title}</h2>
                                <span>
                                    {/* <img src={location} width="15px" alt="" />  */}
                                    {property.location_title}</span>
                                <div class="pri_sale d-flex">
                                    <h4>
                                    {(() => {
                                        switch (property.currency) {
                                        case "AED":   return  new Intl.NumberFormat("en-AE", { style: "currency", currency: "AED", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                        case "USD": return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                        case "GBP":  return new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                        case "EUR":  new Intl.NumberFormat("en-BE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                        case "INR":  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(property.amount.replace(/[AED$£€₹, ]/g, ''));
                                        default:      return "";
                                        }
                                    })()}
                                    </h4>
                                    <h5>SALE</h5>
                                </div>
                                <div class="content_box">
                                    <h3>{property.description_title}</h3>
                                    <br />
                                    <br />
                                    {/* <textarea disabled className="property-description" name="description" id="description" value={property.description_string}></textarea> */}

                                    <div style={{ whiteSpace: 'pre-wrap', fontFamily: 'Gotham Book',lineHeight:'30px' }}>
                                    {property.description_string}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="gallery_gridview"> 
                                <div class="row row-cols-2">
                                    <div class="col-md-4 col-sm-6 col-xs-6 mb-4 d-flex justify-content-center align-items-center">
                                        <div class="text-center">
                                            {property.logo ?
                                                <img className="property-logo-image1" src={ASSETS_URL+"properties/logo/medium/"+property.logo} width="100%" alt="" />
                                            :
                                                <img className="property-media-image1" src={noImage} width="100%" alt="" />
                                            }
                                        </div>
                                    </div>

                                    {propertyPhotos.map((item) => (
                                    <div class="col-md-4 col-sm-6 col-xs-6 mb-4">
                                        <img className="property-media-image1" src={ASSETS_URL+"properties/media/medium/"+item} width="100%" alt="" />
                                    </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="bot_box">
                            <div class="d-flex flex-wrap justify-content-between align-items-center text_he_box">
                                <p>1 May 2025 - Verified Properties </p>
                                <ul>
                                    <li><a href="#">Share <img src={arrowup} alt="" /></a></li>
                                    <li><a href="#">Save <img src={save} alt="" /></a></li>
                                    <li><a href="#">Like <img src={heart} alt="" /></a></li>
                                </ul>
                                <p>Verified Property</p>
                            </div>
                            <span class="border_radius_gredient"></span>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="bottom_secton_box three_bottom_box">
            <div class="container">
                <div class="row justify-content-between">
                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-4">
                        <div class="agent_box">
                            <div class="d-flex justify-content-between align-items-center">
                                <h5>Your Agent</h5>
                                <span>VERIFIED</span>
                            </div>
                            <div class="profile_box text-center">
                                <div class="position-relative d-inline">
                                    {agentImage ?
                                        <img className="agent-profile-picture" src={ASSETS_URL+'agent/profile/'+agentImage} alt=""/>
                                    :
                                        <img className="agent-profile-picture" src={noImage} alt=""/>
                                    }
                                    {agentVerified === 1 &&
                                        <img className="v-agent-profile" src={vshort} alt=""/>
                                    }
                                </div>
                                <h5>{userName}</h5>
                                <h4>{name}</h4>
                                <p>on Verified Properties since 1 May 2025</p>
                            </div>
                            <div class="share_three_box">
                                <div class="d-flex justify-content-between align-items-center">
                                    <a href="#" class="share_btn">SHARE</a>
                                    <a href="#"><img src={heart} alt="" /></a>
                                    <Link to="/chat" class="chat_btn">CHAT</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-4">
                        <div class="agent_box">
                            <div class="d-flex justify-content-between align-items-center">
                                <h5>Your Brokerage</h5>
                                <span>VERIFIED</span>
                            </div>
                            <div class="profile_box text-center">

                                <div class="position-relative d-inline">
                                    {brokerageImage ?
                                        <img className="agent-profile-picture" src={ASSETS_URL+'brokerage/profile/'+brokerageImage} alt=""/>
                                    :
                                        <img className="agent-profile-picture" src={noImage} alt=""/>
                                    }
                                    {brokerageVerified === 1 &&
                                        <img className="v-agent-profile" src={vshort} alt=""/>
                                    }
                                </div>

                                <h5>{brokerageUserName}</h5>
                                <h4>{brokerageName}</h4>
                                <p>on Verified Properties since 1 May 2025</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-4">
                        <div class="agent_box">
                            <div class="d-flex justify-content-between align-items-center">
                                <h5>Your Developer</h5>
                                <span>VERIFIED</span>
                            </div>
                            <div class="profile_box text-center">

                                <div class="position-relative d-inline">
                                    {developerImage ?
                                        <img className="agent-profile-picture" src={ASSETS_URL+'developer/profile/'+developerImage} alt=""/>
                                    :
                                        <img className="agent-profile-picture" src={noImage} alt=""/>
                                    }
                                    {developerVerified === 1 &&
                                        <img className="v-agent-profile" src={vshort} alt=""/>
                                    }
                                </div>

                                <h5>{developerUserName}</h5>
                                <h4>{developerName}</h4>
                                <p>on Verified Properties since 1 May 2025</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <div class="stripbo">
            <div class="container">
                <div class="row">
                <div class="col-md-12"><span class="border_radius_gredient"></span></div>
                    <h4>Verified Properties - United Arab Emirates - Buy - Properties for Sale - {property.title} - 12011768 </h4>
                </div>
            </div>
        </div>

        <Gallery navigation={{
          nextEl: ".image-swiper-button-next",
          prevEl: ".image-swiper-button-prev",
        }}>
            {propertyPhotos.map((item, index) => (
            <Item
                original={ASSETS_URL+"properties/media/original/"+item}
                width="1800"
                height="1024"
                
            >
            {({ ref, open }) => {
                //For first image
                // if (index === 0) {
                //   openFirstImageRef.current = open; // store first image open handler
                // }

                //For current image
                if (index === currentIndex) {
                  openFirstImageRef.current = open; // store first image open handler
                }

                return (
                <img ref={ref} onClick={open} alt=""/>
                );
            }}
            </Item>
            ))}
        </Gallery>
    </>
    );
}

export default Details;